export const STEPPER_BASE_COMPONENTS = {
  1: 'StepInit',
  2: 'Products',
  2.5: 'Shipping',
  3: 'AdditionalServices',
  4: 'PaymentMethods',
  5: 'SignOff',
}

export const STEPPER_ADVANCED_COMPONENTS = {
  ...STEPPER_BASE_COMPONENTS,
  5: 'Packages',
  6: 'Dispersion',
  7: 'SignOff',
}

export const STEPPER_PHANTOM_COMPONENTS = {
  1: 'StepInit',
  2: 'TypeFSignOff',
}

export const OFFER_TYPE = {
  A: 'A',
  B: 'B',
  C: 'C',
  F: 'F',
}

export const VALIDATION_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  RETURNED: 'RETURNED',
}

export const OFFER_STATUS = {
  CREATED: 'CREATED',
  EDITED: 'EDITED',
  SYNCHRONIZED: 'SYNCHRONIZED',
  VALIDATING: 'VALIDATING',
  VALIDATED: 'VALIDATED',
  SIGNING: 'SIGNING',
  SIGNED: 'SIGNED',
}

export const SIGNATURE_STATUS = {
  IN_QUEUE: 'in_queue',
  EMAIL_PROCESSED: 'email_processed',
  EMAIL_DELIVERED: 'email_delivered',
  EMAIL_OPENED: 'email_opened',
  EMAIL_BOUNCED: 'email_bounced',
  DOCUMENT_OPENED: 'document_opened',
  DOCUMENT_SIGNED: 'document_signed',
  DOCUMENT_COMPLETED: 'document_completed',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  AUDIT_TRAIL_COMPLETED: 'audit_trail_completed',
  EXPIRED: 'expired',
  ERROR: 'error',
}

// Terminal signature status, in which the process will no longer continue
export const TERMINAL_SIGNATURE_STATUS = [
  SIGNATURE_STATUS.DOCUMENT_COMPLETED,
  SIGNATURE_STATUS.AUDIT_TRAIL_COMPLETED,
  SIGNATURE_STATUS.DECLINED,
  SIGNATURE_STATUS.CANCELED,
  SIGNATURE_STATUS.EXPIRED,
  SIGNATURE_STATUS.ERROR,
]

export const SIGNATURE_TYPE = {
  DIGITAL: 'DIGITAL',
  MANUAL: 'MANUAL',
}

export const CONTRACT_MODEL = {
  PDF_VENTA_DIRECTA_2021: 'PDF_VENTA_DIRECTA_2021',
  PDF_VENTA_DIRECTA_2022: 'PDF_VENTA_DIRECTA_2022',
  PDF_VENTA_DIRECTA_2023: 'PDF_VENTA_DIRECTA_2023',
  PDF_VENTA_DIRECTA_2024: 'PDF_VENTA_DIRECTA_2024',
  PDF_VENTA_DIRECTA_2025_PT: 'PDF_VENTA_DIRECTA_2025_PT',
  PDF_VENTA_DIRECTA_2025_PT_NEXUS: 'PDF_VENTA_DIRECTA_2025_PT_NEXUS',
  PDF_VENTA_DIRECTA_2025: 'PDF_VENTA_DIRECTA_2025',
  PDF_VENTA_DIRECTA_2026: 'PDF_VENTA_DIRECTA_2026',
  PDF_VENTA_DIRECTA_2026_V2: 'PDF_VENTA_DIRECTA_2026_V2',
  PDF_VENTA_DIRECTA_2026_PT_NEXUS: 'PDF_VENTA_DIRECTA_2026_PT_NEXUS',
  PDF_BROKER_CON_RECOGIDA: 'PDF_BROKER_CON_RECOGIDA',
  PDF_BROKER_SIN_RECOGIDA: 'PDF_BROKER_SIN_RECOGIDA',
}

export const RATE_MODEL_TYPE = {
  BROKER: 'BROKER',
  F: 'F',
}

export const CLIENT_DATA_VALIDATION_SCHEMA = {
  type: 'object',
  properties: {
    clientSocialReason: { type: 'string', minLength: 1 },
    client: {
      type: 'object',
      properties: {
        cif: { type: 'string', minLength: 1 },
        address: { type: 'string', minLength: 1 },
        city: { type: 'string', minLength: 1 },
      },
      required: ['cif', 'address', 'city'],
      additionalProperties: true,
    },
  },
  required: ['clientSocialReason', 'client'],
  additionalProperties: true,
}

export const DEBIT_BANK_DATA_VALIDATION_SCHEMA = {
  type: 'object',
  properties: {
    bankDetails: {
      type: 'object',
      properties: {
        accountIBAN: { type: 'string', minLength: 4, maxLength: 34 },
      },
      required: ['accountIBAN'],
      additionalProperties: true,
    },
  },
  required: ['bankDetails'],
  additionalProperties: true,
}

export const REFUND_BANK_DATA_VALIDATION_SCHEMA = {
  type: 'object',
  properties: {
    bankDetails: {
      type: 'object',
      properties: {
        iban2: { type: 'string', minLength: 4, maxLength: 34 },
      },
      required: ['iban2'],
      additionalProperties: true,
    },
  },
  required: ['bankDetails'],
  additionalProperties: true,
}

export const DEBIT_PAYMENT_METHODS = ['RECD', 'RECD30', 'RECD60','DD']

export const DEFAULT_RATE_MODEL_ID = 1

export const ADMIN_SECTIONS = {
  HOME: 'home',
  OFFERS: 'offers',
  MODELS: 'models',
  TRANSLATIONS: 'translations',
}
